import { MANTRAS } from "@/lib/lunelle-data";
import { LogoMark } from "./Logo";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MANTRAS.map((m) => (
      <span key={m} className="flex items-center">
        <span className="px-8 font-serif text-4xl italic text-[#FBF5EE] sm:px-12 sm:text-6xl">{m}</span>
        <LogoMark className="h-7 w-7 sm:h-9 sm:w-9" color="#C86D51" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden bg-[#2C221E] py-10 sm:py-14" data-testid="editorial-marquee">
    <div className="flex w-max animate-[marquee_70s_linear_infinite] hover:[animation-play-state:paused]">
      <Row />
      <Row hidden />
    </div>
  </section>
);
